<template>
    <div
        class="d-flex flex-column align-start"
    >
        <div
            v-if="hasDiscount || isOnSale"
            class="d-flex gap-2"
        >
            <v-chip
                v-if="hasDiscount"
                class="font-weight-bold text-uppercase letter-spacing-6"
                color="success"
                :size="chipSize"
                label
            >
                {{ currentSku.userDiscountFmt }} Discount
            </v-chip>
            <v-chip
                v-if="isOnSale"
                class="ps-2 font-weight-medium text-uppercase letter-spacing-6"
                variant="outlined"
                color="success"
                :size="chipSize"
                label
            >
                <v-icon
                    :icon="mdiSale"
                    size="16"
                    color="success"
                    class="me-1"
                ></v-icon>
                <span
                    class="text-secondary"
                >
                    <template
                        v-if="currentSku.saleDescription"
                    >
                        {{ currentSku.saleDescription }}
                    </template>
                    <template
                        v-else
                    >
                        On Sale!
                    </template>
                </span>
            </v-chip>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import type { Sku } from '~/types';
    import { mdiSale } from '@mdi/js';


    const props = withDefaults(
        defineProps<{
            currentSku: Sku;
            chipSize?: string | number;

        }>(),
        {
            chipSize: 'small'
        }
    );

    const hasDiscount = computed<boolean>(() => props.currentSku.userDiscount > 0);
    const isOnSale = computed<boolean>(() => props.currentSku.isOnSale);
</script>

<style lang="scss" scoped></style>
